import { Utensils, Store, Compass } from 'lucide-react';
import { partnerData } from '../../../../utils/partnerHelpers';

const ICON_MAP = {
  Utensils,
  Store,
  Compass
};

const CategorySelector = ({ selectedRole, onRoleChange }) => {
  return (
    <div>
      <label className="block text-xs sm:text-sm font-semibold text-slate-700 mb-2 sm:mb-3">
        Select Partner Category
      </label>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4">
        {partnerData.categories.map((type) => {
          const Icon = ICON_MAP[type.icon] || Store;
          const isSelected = selectedRole === type.id;

          return (
            <button
              key={type.id}
              type="button"
              onClick={() => onRoleChange(type.id)}
              className={`p-3.5 sm:p-4 rounded-xl sm:rounded-2xl border-2 flex sm:flex-col items-center justify-center gap-3 sm:gap-2 transition-all cursor-pointer ${
                isSelected
                  ? 'border-[#067978] bg-teal-50/60 text-[#067978]'
                  : 'border-slate-200 text-slate-500 hover:border-[#067978]/50'
              }`}
            >
              <Icon size={22} className="flex-shrink-0" />
              <span className="font-bold text-xs sm:text-sm">{type.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CategorySelector;
